import { ACTIVETRACKING } from "../../actions/portal/";

export default function(state = false, action){
  switch (action.type) {
    case ACTIVETRACKING:
    return action.payload;
    default:
  }

  return state;
}
